import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export const useEmailConfirmationStatus = () => {
  const [isPendingConfirmation, setIsPendingConfirmation] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkEmailStatus = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (user) {
          // Si email_confirmed_at es null, significa que está pendiente de confirmación
          setIsPendingConfirmation(user.email_confirmed_at === null);
        }
      } catch (error) {
        console.error('Error checking email confirmation status:', error);
      } finally {
        setIsLoading(false);
      }
    };

    checkEmailStatus();

    // Escuchar cambios en el estado de auth
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (session?.user) {
        setIsPendingConfirmation(session.user.email_confirmed_at === null);
      }
      setIsLoading(false);
    });

    return () => subscription.unsubscribe();
  }, []);

  return { isPendingConfirmation, isLoading };
};